module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "75%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("First published in Great Britain in 2016 by"), _c('br'), _vm._v("PEN & SWORD MILITARY"), _c('br'), _vm._v("an imprint of"), _c('br'), _vm._v("Pen & Sword Books Ltd,"), _c('br'), _vm._v("47 Church Street,"), _c('br'), _vm._v("Barnsley,"), _c('br'), _vm._v("South Yorkshire"), _c('br'), _vm._v("S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copya"
  }, [_vm._v("Text copyright © Pen and Sword Books, 2016"), _c('br'), _vm._v("Photographs copyright © as credited, 2016")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Every effort has been made to trace the copyright of all the photographs. If there are unintentional omissions, please contact the publisher in writing, who will correct all subsequent editions.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("A CIP record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN: 978 1 47382 752 3"), _c('br'), _vm._v("\nPDF ISBN: 978 1 47387 442 8"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 47387 441 1"), _c('br'), _vm._v("\nPRC ISBN: 978 1 47387 440 4")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The right of Philip S. Jowett to be identified as Author of this Work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Typeset by CHIC GRAPHICS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed and bound by CPI Group (UK) Ltd, Croydon, CR0 4YY")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the imprints of Pen & Sword Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Social History, Transport, True Crime, Claymore Press, Frontline Books, Leo Cooper, Praetorian Press, Remember When, Seaforth Publishing and Wharncliffe.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('i', [_vm._v("For a complete list of Pen & Sword titles please contact")]), _c('br'), _vm._v("Pen & Sword Books Limited"), _c('br'), _vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England"), _c('br'), _vm._v("E-mail: "), _c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_vm._v("enquiries@pen-and-sword.co.uk")]), _c('br'), _vm._v("Website: "), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 63
// module chunks = 0